import React from "react";
import { SVGAsset } from "res";
import "./styles.css";

export default function UIBadge(props) {
    const { text = "", className = "", icon } = props;
    const badgeIcon = icon ? icon : <SVGAsset id="StatusIndicatorCircleIcon" className="icon indicator-circle-icon" />;

    return (
        <div className={`ui-badge set-width flex-container flex-horizontal align-center ${className}`}>
            {badgeIcon}
            <span className="badge-text">{text}</span>
        </div>
    );
}

export function AutopayBadge(props) {
    const { className = "" } = props;

    return <UIBadge className={`autopay-badge success-badge  ${className}`} text="Autopay" />
}

export function EbillsBadge(props) {
    const { className = "" } = props;

    return <UIBadge className={`autopay-badge success-badge  ${className}`} text="eBills" />
}